

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import LazyBg from "../components/LazyBg";
import LazyImage from "../components/LazyImage";
import Globals from "../Globals";
import { useLocation } from "react-router-dom";

const ResField = ({ label, children }) => (
 <div>
 <div style={{fontSize:'0.72rem',fontWeight:'700',color:'#64748b',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.06em'}}>{label}</div>
 {children}
 </div>
);
const resInputCss = {
 width:'100%',padding:'10px 14px',border:'1.5px solid #e2e8f0',borderRadius:'10px',
 fontSize:'0.92rem',color:'#0f172a',outline:'none',background:'white',
 boxSizing:'border-box',transition:'border-color 0.15s',fontFamily:'inherit',
};
const onFocusRes = e => { e.target.style.borderColor='#01225C'; e.target.style.boxShadow='0 0 0 3px rgba(1,34,92,0.1)'; };
const onBlurRes = e => { e.target.style.borderColor='#e2e8f0'; e.target.style.boxShadow='none'; };

const Stepper = ({ value, min, max, onChange }) => (
 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
 <button type="button" onClick={() => value > min && onChange(value - 1)}
 style={{ width: '30px', height: '30px', borderRadius: '50%', border: '1.5px solid ' + (value <= min ? '#e2e8f0' : '#94a3b8'), background: 'white', cursor: value <= min ? 'not-allowed' : 'pointer', fontSize: '1.15rem', lineHeight: 1, color: value <= min ? '#cbd5e1' : '#475569', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s', flexShrink: 0 }}>−</button>
 <span style={{ minWidth: '18px', textAlign: 'center', fontWeight: '700', fontSize: '1rem', color: '#0f172a' }}>{value}</span>
 <button type="button" onClick={() => value < max && onChange(value + 1)}
 style={{ width: '30px', height: '30px', borderRadius: '50%', border: '1.5px solid ' + (value >= max ? '#e2e8f0' : '#01225C'), background: value >= max ? '#f8fafc' : '#01225C', cursor: value >= max ? 'not-allowed' : 'pointer', fontSize: '1.15rem', lineHeight: 1, color: value >= max ? '#cbd5e1' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s', flexShrink: 0 }}>+</button>
 </div>
);


// Toast Component
const Toast = ({ message, type = 'info', onClose }) => {
 useEffect(() => {
 const timer = setTimeout(onClose, 5000);
 return () => clearTimeout(timer);
 }, [onClose]);

 const icons = {
 success: '✓',
 error: '✕',
 warning: '⚠',
 info: 'ℹ'
 };

 const colors = {
 success: { bg: '#d4edda', border: '#c3e6cb', text: '#155724' },
 error: { bg: '#f8d7da', border: '#f5c6cb', text: '#721c24' },
 warning: { bg: '#fff3cd', border: '#ffeaa7', text: '#856404' },
 info: { bg: '#d1ecf1', border: '#bee5eb', text: '#0c5460' }
 };

 const color = colors[type];

 return (
 <div style={{
 position: 'fixed',
 bottom: '24px',
 left: '24px',
 zIndex: 999999,
 background: color.bg,
 border: `1.5px solid ${color.border}`,
 borderRadius: '10px',
 padding: '10px 14px',
 minWidth: '220px',
 maxWidth: '340px',
 boxShadow: '0 4px 20px rgba(0,0,0,0.18)',
 animation: 'slideIn 0.25s ease-out',
 display: 'flex',
 alignItems: 'center',
 gap: '10px'
 }}>
 <div style={{
 width: '26px',
 height: '26px',
 borderRadius: '50%',
 background: color.text,
 color: color.bg,
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 fontSize: '0.9rem',
 fontWeight: 'bold',
 flexShrink: 0
 }}>
 {icons[type]}
 </div>
 <div style={{ flex: 1, color: color.text, fontSize: '0.82rem', lineHeight: '1.4' }}>
 {message}
 </div>
 <button
 onClick={onClose}
 style={{
 background: 'transparent',
 border: 'none',
 color: color.text,
 fontSize: '1.2rem',
 cursor: 'pointer',
 padding: '0',
 width: '20px',
 height: '20px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 opacity: 0.7,
 transition: 'opacity 0.2s'
 }}
 onMouseEnter={(e) => e.target.style.opacity = '1'}
 onMouseLeave={(e) => e.target.style.opacity = '0.7'}
 >
 ×
 </button>
 <style>{`
 @keyframes slideIn {
 from { transform: translateX(-60px); opacity: 0; }
 to { transform: translateX(0); opacity: 1; }
 }
 `}</style>
 </div>
 );
};

// Extract minimum price from HotelSearch Price object
// REAL API shape: Price.Boarding[].Pax[].Rooms[].{ Price, PriceWithAffiliateMarkup }
// We display PriceWithAffiliateMarkup (client price incl. markup) when available.
const getMinPrice = (priceObj) => {
 if (!priceObj) return null;
 if (priceObj.Boarding) {
 let min = Infinity, boardingName = null;
 for (const b of priceObj.Boarding) {
 for (const pax of (b.Pax || [])) {
 for (const r of (pax.Rooms || [])) {
 const p = Number(r.PriceWithAffiliateMarkup ?? r.Price);
 if (!isNaN(p) && p > 0 && p < min) { min = p; boardingName = b.Name || b.Code || null; }
 }
 }
 }
 if (min !== Infinity) return { price: min, boarding: boardingName };
 }
 if (typeof priceObj === 'number' && priceObj > 0) return { price: priceObj, boarding: null };
 const flat = Number(priceObj.Amount ?? priceObj.TotalAmount ?? priceObj.Price ?? priceObj.MinPrice);
 if (!isNaN(flat) && flat > 0) return { price: flat, boarding: priceObj.BoardingName || null };
 return null;
};

// Extract all boarding options with min price per boarding from HotelSearch Price object
const getBoardingPrices = (priceObj) => {
 if (!priceObj?.Boarding) return [];
 return priceObj.Boarding.map(b => {
 let min = Infinity;
 // REAL API: Rooms are nested under Boarding[].Pax[]
 for (const pax of (b.Pax || [])) {
 for (const r of (pax.Rooms || [])) {
 const p = Number(r.PriceWithAffiliateMarkup ?? r.Price);
 if (!isNaN(p) && p > 0 && p < min) min = p;
 }
 }
 return min !== Infinity ? { name: b.Name, code: b.Code, price: min } : null;
 }).filter(Boolean);
};

const HotelList = () => {
 const [hotels, setHotels] = useState([]);
 const [loading, setLoading] = useState(true);
 const [searchProgress, setSearchProgress] = useState({ current: 0, total: 0 });
 const [error, setError] = useState(null);
 const [currentPage, setCurrentPage] = useState(1);
 const [selectedHotel, setSelectedHotel] = useState(null);
 const [showModal, setShowModal] = useState(false);
 const hotelsPerPage = 6;
 const [checkIn, setCheckIn] = useState(null);
 const [checkOut, setCheckOut] = useState(null);
 const [rooms, setRooms] = useState([{ adults: 2, children: [] }]);
 const [showRoomPicker, setShowRoomPicker] = useState(false);
 const roomPickerRef = React.useRef(null);
 const triggerBtnRef = React.useRef(null);
 const [pickerPos, setPickerPos] = useState({ top: 0, left: 0, width: 340 });
 const [starRating, setStarRating] = useState('');
 const [isSearchActive, setIsSearchActive] = useState(false);
 const [originalHotels, setOriginalHotels] = useState([]);
const [selectedCity, setSelectedCity] = useState('');
const [toast, setToast] = useState(null);
const [cities, setCities] = useState([]);
const [hotelDetails, setHotelDetails] = useState(new Map());
const [availableTags, setAvailableTags] = useState([]);
const [selectedTags, setSelectedTags] = useState([]);
const [searchKeyword, setSearchKeyword] = useState('');
const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
const [selectedBoarding, setSelectedBoarding] = useState(null);
const [inlineFilter, setInlineFilter] = useState('');
const [showResModal, setShowResModal] = useState(false);
const [resStep, setResStep] = useState(1);
const [resHotel, setResHotel] = useState(null);
const [resForm, setResForm] = useState({ nom_prenom:'', email:'', adresse:'', ville:'', telephone:'', whatsapp:'', mode_paiement:'', demande_specifique:'Réservation hôtel', remarque:'' });
const [resSending, setResSending] = useState(false);
const [resSent, setResSent] = useState(false);
const [resFieldErrors, setResFieldErrors] = useState({});
const location = useLocation();

const [pendingSearch, setPendingSearch] = useState(false);
 
useEffect(() => {
 if (location.state && location.state.searchParams) {
 const params = location.state.searchParams;
 if (params.checkIn) setCheckIn(params.checkIn);
 if (params.checkOut) setCheckOut(params.checkOut);
 if (params.adultes || params.enfants) {
 const adults = params.adultes ? parseInt(params.adultes) : 2;
 const childCnt = params.enfants ? parseInt(params.enfants) : 0;
 setRooms([{ adults, children: Array(childCnt).fill(null).map(() => ({ age: 5 })) }]);
 }
 if (params.ville && params.ville !== 'Toutes les villes') {
 setSelectedCity(params.ville);
 }
 if (params.etoiles && params.etoiles !== 'Toutes') {
 setStarRating(params.etoiles.split(' ')[0]);
 }
 setPendingSearch(true);
 }
}, [location.state]);

useEffect(() => {
 if (pendingSearch && originalHotels.length > 0) {
 setPendingSearch(false);
 handleSearch();
 }
}, [pendingSearch, originalHotels.length]);
 const showToast = (message, type = 'info') => {
 setToast({ message, type });
};

 // Fetch the rich HotelDetail for a SINGLE hotel, on demand, cached after first load.
 // (We used to prefetch all 449 hotels at page load — hundreds of requests + re-renders
 //  made the page extremely slow. Details are only needed when a modal opens.)
 const fetchHotelDetail = async (hotelId) => {
 if (!hotelId || hotelDetails.has(hotelId)) return;
 try {
 const res = await fetch(`${Globals.hotelProvider.baseUrl}${Globals.endpoints.hotelDetail}`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({
 Credential: { Login: Globals.hotelProvider.login, Password: Globals.hotelProvider.password },
 Hotel: hotelId,
 }),
 });
 const d = await res.json();
 if (d.HotelDetail) {
 setHotelDetails(prev => { const n = new Map(prev); n.set(hotelId, d.HotelDetail); return n; });
 }
 } catch { /* silently skip */ }
 };

 const handleSearch = async () => {
 if (!originalHotels || originalHotels.length === 0) {
 showToast("Aucun hôtel disponible pour la recherche.", 'error');
 return;
 }
 
 // Local pre-filtering (stars, city, keyword)
 let hotelsToSearch = originalHotels;

 if (searchKeyword.trim()) {
 const kw = searchKeyword.trim().toLowerCase();
 hotelsToSearch = hotelsToSearch.filter(h =>
 h.Name?.toLowerCase().includes(kw) ||
 h.City?.Name?.toLowerCase().includes(kw) ||
 h.Adress?.toLowerCase().includes(kw)
 );
 }

 if (starRating) {
 hotelsToSearch = hotelsToSearch.filter(h => h.Category && h.Category.Star && parseInt(h.Category.Star) === parseInt(starRating));
 }

 if (selectedCity) {
 const cityId = parseInt(selectedCity);
 hotelsToSearch = hotelsToSearch.filter(h => h.City?.Id === cityId);
 }

 if (hotelsToSearch.length === 0) {
 showToast("Aucun hôtel trouvé avec ces filtres.", 'warning');
 setHotels([]);
 setIsSearchActive(true);
 return;
 }

 // IF DATES ARE NOT SELECTED, JUST DO LOCAL FILTERING
 if (!checkIn || !checkOut) {
 setHotels(hotelsToSearch);
 setSearchProgress({ current: hotelsToSearch.length, total: hotelsToSearch.length });
 setIsSearchActive(true);
 setCurrentPage(1);
 setTimeout(() => {
 const resultsEl = document.getElementById('results-section');
 if (resultsEl) {
 const y = resultsEl.getBoundingClientRect().top + window.scrollY - 100;
 window.scrollTo({ top: y, behavior: 'smooth' });
 }
 }, 100);
 return;
 }

 // IF DATES ARE SELECTED — HotelSearch per city (City is MANDATORY per API doc)
 const checkInDate = new Date(checkIn);
 const checkOutDate = new Date(checkOut);
 const today = new Date();
 today.setHours(0, 0, 0, 0);

 if (checkInDate < today) { showToast("La date d'entrée ne peut pas être dans le passé.", 'error'); return; }
 if (checkOutDate <= checkInDate) { showToast("La date de sortie doit être après la date d'entrée.", 'error'); return; }

 // Real API: Rooms is an ARRAY of { Adult, Child[] } (one entry per room)
 const roomsPayload = rooms.map(r => ({ Adult: r.adults, Child: r.children.map(c => c.age) }));

 // City is MANDATORY → we must search per unique city among the hotels we want
 const cityIds = [...new Set(hotelsToSearch.map(h => h.City?.Id).filter(Boolean))];
 const wantedIds = new Set(hotelsToSearch.map(h => h.Id));

 if (cityIds.length === 0) {
 showToast("Aucune ville identifiée pour ces hôtels.", 'warning');
 return;
 }

 setLoading(true);
 setError(null);
 setHotels([]);
 setSearchProgress({ current: 0, total: cityIds.length });
 setIsSearchActive(true);
 setCurrentPage(1);

 const allAvailableHotels = [];
 const seenIds = new Set();
 let completed = 0;

 const searchCity = async (cityId) => {
 const searchPayload = {
 Credential: { Login: Globals.hotelProvider.login, Password: Globals.hotelProvider.password },
 SearchDetails: {
 BookingDetails: {
 CheckIn: checkIn,
 CheckOut: checkOut,        // Real API: capital 'O' (doc is wrong)
 City: cityId,              // MANDATORY
 },
 Filters: {
 OnlyAvailable: true,
 ...(selectedTags.length > 0 ? { Tags: selectedTags } : {}),
 },
 Rooms: roomsPayload,
 },
 };
 try {
 const response = await fetch(`${Globals.hotelProvider.baseUrl}${Globals.endpoints.hotelSearch}`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify(searchPayload),
 });
 const data = await response.json();
 if (data.ErrorMessage && data.ErrorMessage.Code) {
 console.warn('[HotelSearch] city', cityId, 'ErrorMessage:', data.ErrorMessage);
 } else {
 // Real API: results are under "HotelSearch"; hotel info is nested in item.Hotel,
 // while Token / Price / Currency are siblings at the item level
 const searchResults = data.HotelSearch || [];
 for (const item of searchResults) {
 const hid = item.Hotel?.Id;
 if (!hid || seenIds.has(hid) || !wantedIds.has(hid)) continue;
 seenIds.add(hid);
 allAvailableHotels.push({ ...item.Hotel, SearchToken: item.Token, AvailablePrices: item.Price ?? null, Currency: item.Currency });
 }
 }
 } catch (e) {
 console.error('[HotelSearch] city', cityId, 'failed:', e);
 } finally {
 completed++;
 setSearchProgress({ current: completed, total: cityIds.length });
 setHotels([...allAvailableHotels]);
 }
 };

 try {
 // Run city searches with limited concurrency for speed without hammering the provider
 const CONCURRENCY = 6;
 let cursor = 0;
 const worker = async () => {
 while (cursor < cityIds.length) {
 const idx = cursor++;
 await searchCity(cityIds[idx]);
 }
 };
 await Promise.all(Array.from({ length: Math.min(CONCURRENCY, cityIds.length) }, worker));

 if (allAvailableHotels.length === 0) {
 showToast('Aucun hôtel disponible pour les dates sélectionnées.', 'warning');
 setHotels([]);
 } else {
 setHotels([...allAvailableHotels]);
 }
 } catch (err) {
 console.error('Search error:', err);
 setError(`Une erreur s'est produite: ${err.message}`);
 setHotels([]);
 } finally {
 setLoading(false);
 setSearchProgress({ current: 0, total: 0 });
 setTimeout(() => {
 const resultsEl = document.getElementById('results-section');
 if (resultsEl) window.scrollTo({ top: resultsEl.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
 }, 100);
 }
 };

 const handleResetSearch = () => {
 setHotels(originalHotels);
 setCheckIn(null);
 setCheckOut(null);
 setRooms([{ adults: 2, children: [] }]);
 setStarRating('');
 setCurrentPage(1);
 setIsSearchActive(false);
 setSelectedCity('');
 setSelectedTags([]);
 setSearchKeyword('');
 setInlineFilter('');
 };

 useEffect(() => {
 if (!showRoomPicker) return;
 const handle = (e) => {
 if (
 roomPickerRef.current && !roomPickerRef.current.contains(e.target) &&
 triggerBtnRef.current && !triggerBtnRef.current.contains(e.target)
 ) setShowRoomPicker(false);
 };
 document.addEventListener('mousedown', handle);
 return () => document.removeEventListener('mousedown', handle);
 }, [showRoomPicker]);

 const calcPickerPos = () => {
 if (!triggerBtnRef.current) return;
 const rect = triggerBtnRef.current.getBoundingClientRect();
 const pw = Math.max(rect.width, 380);
 const spaceBelow = window.innerHeight - rect.bottom;
 const spaceAbove = rect.top;
 const openUpward = spaceBelow < 300 && spaceAbove > spaceBelow;
 const left = rect.left + pw > window.innerWidth - 10 ? Math.max(8, rect.right - pw) : rect.left;
 setPickerPos({ top: openUpward ? null : rect.bottom + 6, bottom: openUpward ? window.innerHeight - rect.top + 6 : null, left, width: pw });
 };

 const openRoomPicker = () => {
 calcPickerPos();
 setShowRoomPicker(v => !v);
 };

 useEffect(() => {
 if (!showRoomPicker) return;
 const sync = () => {
 if (!triggerBtnRef.current) return;
 const rect = triggerBtnRef.current.getBoundingClientRect();
 if (rect.top < -10 || rect.bottom > window.innerHeight + 10) { setShowRoomPicker(false); return; }
 const pw = Math.max(rect.width, 380);
 const spaceBelow = window.innerHeight - rect.bottom;
 const spaceAbove = rect.top;
 const openUpward = spaceBelow < 300 && spaceAbove > spaceBelow;
 const left = rect.left + pw > window.innerWidth - 10 ? Math.max(8, rect.right - pw) : rect.left;
 setPickerPos({ top: openUpward ? null : rect.bottom + 6, bottom: openUpward ? window.innerHeight - rect.top + 6 : null, left, width: pw });
 };
 window.addEventListener('scroll', sync, { passive: true, capture: true });
 window.addEventListener('resize', sync, { passive: true });
 return () => {
 window.removeEventListener('scroll', sync, { capture: true });
 window.removeEventListener('resize', sync);
 };
 }, [showRoomPicker]);

 const addRoom = () => {
 if (rooms.length < 4) setRooms(prev => [...prev, { adults: 2, children: [] }]);
 };
 const removeRoom = (idx) => {
 if (rooms.length > 1) setRooms(prev => prev.filter((_, i) => i !== idx));
 };
 const updateRoomAdults = (idx, val) => {
 setRooms(prev => prev.map((r, i) => i === idx ? { ...r, adults: Math.max(1, Math.min(4, val)) } : r));
 };
 const updateRoomChildren = (idx, count) => {
 setRooms(prev => prev.map((r, i) => {
 if (i !== idx) return r;
 const cnt = Math.max(0, Math.min(4, count));
 const children = [...r.children];
 while (children.length < cnt) children.push({ age: 5 });
 children.length = cnt;
 return { ...r, children };
 }));
 };
 const updateChildAge = (roomIdx, childIdx, age) => {
 setRooms(prev => prev.map((r, i) => {
 if (i !== roomIdx) return r;
 return { ...r, children: r.children.map((c, j) => j === childIdx ? { age } : c) };
 }));
 };

 const openResModal = () => {
 const priceInfo = getMinPrice(selectedHotel.AvailablePrices ?? selectedHotel.Price);
 setResHotel({
 name: selectedHotel.Name,
 stars: selectedHotel.Category?.Star || 0,
 city: selectedHotel.City?.Name || '',
 image: selectedHotel.Image || '/assets/img/default-hotel.jpg',
 arrangement: selectedBoarding?.name || null,
 arrangementPrice: selectedBoarding?.price || null,
 price: priceInfo?.price || null,
 checkIn, checkOut,
 roomsCount: rooms.length,
 adults: totalAdults,
 children: totalChildren,
 });
 setResStep(1);
 setResForm({ nom_prenom:'', email:'', adresse:'', ville:'', telephone:'', whatsapp:'', mode_paiement:'', demande_specifique:'Réservation hôtel', remarque:'' });
 setResSent(false);
 setResFieldErrors({});
 // Fermer le modal hôtel avant d'ouvrir le stepper
 setShowModal(false);
 setSelectedHotel(null);
 setSelectedBoarding(null);
 setShowResModal(true);
 document.body.style.overflow = 'hidden';
 };

 const closeResModal = () => {
 setShowResModal(false);
 document.body.style.overflow = 'unset';
 };

 const submitReservation = async () => {
 const errors = {};
 if (!resForm.nom_prenom.trim()) errors.nom_prenom = 'Ce champ est obligatoire';
 if (!resForm.email.trim()) errors.email = 'Ce champ est obligatoire';
 else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(resForm.email.trim())) errors.email = 'Adresse email invalide';
 if (!resForm.telephone.trim()) errors.telephone = 'Ce champ est obligatoire';
 if (Object.keys(errors).length > 0) {
 setResFieldErrors(errors);
 showToast('Veuillez corriger les champs en rouge.', 'warning');
 return;
 }
 setResFieldErrors({});
 setResSending(true);
 try {
 const r = await fetch(`${Globals.API}/reservations/hotel`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({
 ...resForm,
 hotel_name: resHotel.name,
 hotel_stars: resHotel.stars,
 hotel_city: resHotel.city,
 hotel_arrangement: resHotel.arrangement || 'Non précisé',
 hotel_checkin: resHotel.checkIn || 'Non précisé',
 hotel_checkout: resHotel.checkOut || 'Non précisé',
 hotel_rooms: resHotel.roomsCount,
 hotel_adults: resHotel.adults,
 hotel_children: resHotel.children,
 hotel_price: resHotel.arrangementPrice
 ? `${Number(resHotel.arrangementPrice).toLocaleString('fr-TN',{minimumFractionDigits:3})} TND`
 : resHotel.price ? `${Number(resHotel.price).toLocaleString('fr-TN',{minimumFractionDigits:3})} TND` : 'Sur demande',
 }),
 });
 const d = await r.json();
 if (d.success) { setResSent(true); setResStep(3); }
 else showToast(d.message || "Erreur lors de l'envoi de la réservation.", 'error');
 } catch { showToast("Erreur réseau. Veuillez réessayer.", 'error'); }
 setResSending(false);
 };

 useEffect(() => {
 const fetchHotels = async () => {
 try {
 const response = await fetch(`${Globals.hotelProvider.baseUrl}${Globals.endpoints.listHotel}`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({
 Credential: { Login: Globals.hotelProvider.login, Password: Globals.hotelProvider.password },
 }),
 });
 const data = await response.json();
 // Deduplicate by Id — ListHotel can return the same hotel more than once,
 // which causes hotels to repeat across pagination pages
 const rawList = data.ListHotel || [];
 const seenHotelIds = new Set();
 const hotelList = rawList.filter(h => {
 if (!h?.Id || seenHotelIds.has(h.Id)) return false;
 seenHotelIds.add(h.Id);
 return true;
 });
 setHotels(hotelList);
 setOriginalHotels(hotelList);

 const cityMap = new Map();
 hotelList.forEach(hotel => {
 if (hotel.City?.Id && !cityMap.has(hotel.City.Id)) cityMap.set(hotel.City.Id, hotel.City);
 });
 setCities(Array.from(cityMap.values()).sort((a, b) => a.Name.localeCompare(b.Name)));


 // Fetch available tags
 fetch(`${Globals.hotelProvider.baseUrl}${Globals.endpoints.listTag}`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({ Credential: { Login: Globals.hotelProvider.login, Password: Globals.hotelProvider.password } }),
 })
 .then(r => r.json())
 .then(d => { if (d.ListTag) setAvailableTags(d.ListTag); })
 .catch(() => {});
 } catch (err) {
 setError(err.message);
 } finally {
 setLoading(false);
 }
 };

 fetchHotels();
 }, []);

 const totalAdults = rooms.reduce((s, r) => s + r.adults, 0);
 const totalChildren = rooms.reduce((s, r) => s + r.children.length, 0);

 const filteredForDisplay = inlineFilter.trim()
 ? hotels.filter(h => h.Name?.toLowerCase().includes(inlineFilter.trim().toLowerCase()) || h.City?.Name?.toLowerCase().includes(inlineFilter.trim().toLowerCase()))
 : hotels;

 const indexOfLastHotel = currentPage * hotelsPerPage;
 const indexOfFirstHotel = indexOfLastHotel - hotelsPerPage;
 const currentHotels = filteredForDisplay.slice(indexOfFirstHotel, indexOfLastHotel);
 const totalPages = Math.ceil(filteredForDisplay.length / hotelsPerPage);

 const paginate = (pageNumber) => {
 setCurrentPage(pageNumber);
 const resultsEl = document.getElementById('results-section');
 if (resultsEl) {
 const y = resultsEl.getBoundingClientRect().top + window.scrollY - 100;
 window.scrollTo({ top: y, behavior: 'smooth' });
 } else {
 window.scrollTo({ top: 0, behavior: 'smooth' });
 }
 };

 const openModal = (hotel) => {
 setSelectedHotel(hotel);
 setShowModal(true);
 document.body.style.overflow = 'hidden';
 // Lazy-load the rich detail for THIS hotel only (cached after first open)
 fetchHotelDetail(hotel.Id);
 };

 const closeModal = () => {
 setShowModal(false);
 setSelectedHotel(null);
 setSelectedBoarding(null);
 document.body.style.overflow = 'unset';
 };

 if (error) {
 return (
 <div style={{padding: '40px', textAlign: 'center', color: '#dc3545', backgroundColor: '#f8d7da', borderRadius: '8px', margin: '20px'}}>
 <i className="fa fa-exclamation-triangle" style={{fontSize: '2rem', marginBottom: '10px'}}></i>
 <p style={{fontSize: '1.1rem', margin: '10px 0'}}>Erreur: {error}</p>
 </div>
 );
 }

 return (
 <>
 <LazyBg src="/assets/img/hotelh-new.jpg" className="container-fluid py-3 mb-5 hero-header" style={{backgroundSize:"cover", backgroundPosition:"center", textShadow: '0 2px 8px rgba(0,0,0,0.5)'}}>
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">Nos Hôtels en Tunisie</h1>
 </div>
 </div>
 </div>
 </LazyBg>
 
 <div className="container pt-5 pb-3" id="results-section">
 <div className="text-center mb-5">
 <h6 className="bg-white text-center px-3" style={{color:'#003DA6'}}>Hébergement</h6>
 <h1 className="mb-3" style={{color: '#01225C'}}>Découvrez Nos Hôtels</h1>
 <p style={{color: '#6c757d', maxWidth: '700px', margin: '0 auto'}}>
 {loading ? (
 <span>
 <i className="fa fa-spinner fa-spin me-2"></i>
 Recherche en cours... {hotels.length} hôtel{hotels.length > 1 ? 's' : ''} trouvé{hotels.length > 1 ? 's' : ''}
 </span>
 ) : (
 <>
 {hotels.length} hôtel{hotels.length > 1 ? 's' : ''} {isSearchActive ? 'disponible' + (hotels.length > 1 ? 's' : '') + ' pour vos dates' : 'disponible' + (hotels.length > 1 ? 's' : '') + ' pour votre séjour en Tunisie'}
 </>
 )}
 </p>
 </div>

 <div className="mb-4">
 <div className="card" style={{border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', borderRadius: '15px', overflow: 'hidden'}}>
 <div className="card-body p-4">
 <div className="row g-3">
 <div className="col-md-3">
 <label className="form-label fw-semibold" style={{color: '#01225C'}}>
 <i className="fa fa-calendar-check me-2"></i>Check-In
 </label>
 <input 
 type="date" 
 className="form-control"
 value={checkIn || ''}
 min={new Date().toISOString().split('T')[0]}
 onChange={(e) => setCheckIn(e.target.value)}
 style={{borderColor: '#dee2e6', borderRadius: '8px'}}
 />
 </div>

 <div className="col-md-3">
 <label className="form-label fw-semibold" style={{color: '#01225C'}}>
 <i className="fa fa-calendar-times me-2"></i>Check-Out
 </label>
 <input 
 type="date" 
 className="form-control"
 value={checkOut || ''}
 min={checkIn || new Date().toISOString().split('T')[0]}
 onChange={(e) => setCheckOut(e.target.value)}
 style={{borderColor: '#dee2e6', borderRadius: '8px'}}
 />
 </div>

 <div className="col-md-6">
 <label className="form-label fw-semibold" style={{color: '#01225C'}}>
 <i className="fa fa-users me-2"></i>Chambres et Occupation
 </label>
 <button ref={triggerBtnRef} type="button" onClick={openRoomPicker}
 style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
 padding: '8px 14px', background: 'white', border: `1px solid ${showRoomPicker ? '#01225C' : '#dee2e6'}`,
 borderRadius: '8px', fontSize: '0.9rem', color: '#212529', cursor: 'pointer', height: '38px',
 boxShadow: showRoomPicker ? '0 0 0 3px rgba(1,34,92,0.1)' : 'none', transition: 'all 0.15s'}}>
 <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
 <i className="fa fa-bed" style={{color: '#01225C', fontSize: '0.9rem'}}></i>
 <span style={{fontWeight: '500'}}>
 {rooms.length} chambre{rooms.length > 1 ? 's' : ''} &nbsp;·&nbsp; {totalAdults} adulte{totalAdults > 1 ? 's' : ''}
 {totalChildren > 0 && ` · ${totalChildren} enfant${totalChildren > 1 ? 's' : ''}`}
 </span>
 </span>
 <i className={`fa fa-chevron-${showRoomPicker ? 'up' : 'down'}`} style={{color: '#94a3b8', fontSize: '0.75rem'}}></i>
 </button>
 </div>

 {showRoomPicker && createPortal(
 <>
 <style>{`
 @keyframes pickerIn { from { opacity:0; transform:translateY(-6px) scale(0.98); } to { opacity:1; transform:translateY(0) scale(1); } }
 .room-picker-panel { animation: pickerIn 0.18s cubic-bezier(0.22,1,0.36,1) both; }
 .stepper-btn:hover:not(:disabled) { transform: scale(1.08); }
 `}</style>
 <div ref={roomPickerRef} className="room-picker-panel" style={{
 position: 'fixed',
 top: pickerPos.top ?? 'auto',
 bottom: pickerPos.bottom ?? 'auto',
 left: pickerPos.left,
 width: pickerPos.width,
 background: 'white', borderRadius: '16px',
 boxShadow: '0 20px 60px rgba(1,34,92,0.18), 0 4px 16px rgba(0,0,0,0.08)',
 border: '1px solid rgba(1,34,92,0.12)',
 zIndex: 99999, overflow: 'hidden'}}>
 {/* Header */}
 <div style={{padding: '14px 20px 10px', borderBottom: '1px solid #f1f5f9'}}>
 <span style={{fontSize: '0.68rem', fontWeight: '800', color: '#94a3b8', letterSpacing: '0.1em', textTransform: 'uppercase'}}>Chambres et Occupation</span>
 </div>

 <div style={{maxHeight: '70vh', overflowY: 'auto', padding: '8px 0'}}>
 {rooms.map((room, rIdx) => (
 <div key={rIdx} style={{padding: '14px 20px', borderBottom: rIdx < rooms.length - 1 ? '1px solid #f1f5f9' : 'none'}}>
 {/* Room header */}
 <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px'}}>
 <span style={{fontWeight: '700', color: '#01225C', fontSize: '0.9rem', letterSpacing: '-0.01em'}}>
 Chambre {rIdx + 1}
 </span>
 {rooms.length > 1 && (
 <button type="button" onClick={() => removeRoom(rIdx)}
 style={{background: '#fef2f2', border: 'none', borderRadius: '8px', cursor: 'pointer',
 color: '#ef4444', padding: '4px 8px', fontSize: '0.75rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px'}}>
 <i className="fa fa-trash" style={{fontSize: '0.7rem'}}></i> Supprimer
 </button>
 )}
 </div>

 {/* Adultes row */}
 <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px'}}>
 <div>
 <div style={{fontWeight: '600', fontSize: '0.88rem', color: '#0f172a'}}>Adulte(s)</div>
 <div style={{fontSize: '0.72rem', color: '#94a3b8', marginTop: '1px'}}>12 ans et +</div>
 </div>
 <Stepper value={room.adults} min={1} max={4} onChange={v => updateRoomAdults(rIdx, v)} />
 </div>

 {/* Enfants row */}
 <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
 <div>
 <div style={{fontWeight: '600', fontSize: '0.88rem', color: '#0f172a'}}>Enfant(s)</div>
 <div style={{fontSize: '0.72rem', color: '#94a3b8', marginTop: '1px'}}>Moins de 12 ans</div>
 </div>
 <Stepper value={room.children.length} min={0} max={4} onChange={v => updateRoomChildren(rIdx, v)} />
 </div>

 {/* Child ages */}
 {room.children.length > 0 && (
 <div style={{marginTop: '12px', padding: '12px', background: '#f8fafc', borderRadius: '10px'}}>
 <div style={{fontSize: '0.68rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '10px'}}>
 Âge de chaque enfant
 </div>
 <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
 {room.children.map((child, cIdx) => (
 <div key={cIdx} style={{textAlign: 'center'}}>
 <div style={{fontSize: '0.68rem', color: '#64748b', marginBottom: '5px', fontWeight: '500'}}>Enfant {cIdx + 1}</div>
 <select value={child.age} onChange={e => updateChildAge(rIdx, cIdx, parseInt(e.target.value))}
 style={{width: '66px', padding: '5px 4px', borderRadius: '8px', border: '1px solid #e2e8f0', textAlign: 'center',
 fontSize: '0.85rem', color: '#0f172a', background: 'white', cursor: 'pointer', fontWeight: '600'}}>
 {Array.from({length: 18}, (_, i) => <option key={i} value={i}>{i} an{i > 1 ? 's' : ''}</option>)}
 </select>
 </div>
 ))}
 </div>
 </div>
 )}
 </div>
 ))}
 </div>

 {/* Footer */}
 <div style={{padding: '12px 20px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafbfc'}}>
 <button type="button" onClick={addRoom} disabled={rooms.length >= 4}
 style={{background: 'none', border: '1.5px solid #01225C', color: '#01225C', borderRadius: '8px',
 padding: '7px 14px', fontSize: '0.82rem', fontWeight: '700',
 cursor: rooms.length >= 4 ? 'not-allowed' : 'pointer', opacity: rooms.length >= 4 ? 0.35 : 1,
 display: 'flex', alignItems: 'center', gap: '6px', transition: 'all 0.15s'}}>
 <i className="fa fa-plus" style={{fontSize: '0.75rem'}}></i> Ajouter chambre
 </button>
 <button type="button" onClick={() => setShowRoomPicker(false)}
 style={{background: 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', border: 'none',
 color: 'white', borderRadius: '8px', padding: '7px 20px', fontSize: '0.82rem', fontWeight: '700',
 cursor: 'pointer', boxShadow: '0 2px 8px rgba(1,34,92,0.25)'}}>
 Valider
 </button>
 </div>
 </div>
 </>,
 document.body
 )}

 <div className="col-md-2">
 <label className="form-label fw-semibold" style={{color: '#01225C'}}>
 <i className="fa fa-star me-2"></i>Étoiles
 </label>
 <select 
 className="form-select" 
 value={starRating}
 onChange={(e) => setStarRating(e.target.value)}
 style={{borderColor: '#dee2e6', borderRadius: '8px'}}
 >
 <option value="">Toutes</option>
 <option value="3">3 ★★★</option>
 <option value="4">4 ★★★★</option>
 <option value="5">5 ★★★★★</option>
 </select>
 </div>

 <div className="col-md-3">
 <label className="form-label fw-semibold" style={{color: '#01225C'}}>
 <i className="fa fa-map-marker-alt me-2"></i>Ville
 </label>
 <select
 className="form-select"
 value={selectedCity}
 onChange={(e) => setSelectedCity(e.target.value)}
 style={{borderColor: '#dee2e6', borderRadius: '8px'}}
 >
 <option value="">Toutes les villes</option>
 {cities.map(city => (
 <option key={city.Id} value={city.Id}>{city.Name}</option>
 ))}
 </select>
</div>

<div className="col-md-3">
 <label className="form-label fw-semibold" style={{color: '#01225C'}}>
 <i className="fa fa-search me-2"></i>Recherche par nom
 </label>
 <input
 type="text"
 className="form-control"
 placeholder="Taper le nom de l'hôtel ou la ville"
 value={searchKeyword}
 onChange={(e) => setSearchKeyword(e.target.value)}
 onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
 style={{borderColor: '#dee2e6', borderRadius: '8px'}}
 />
</div>


 <div className="col-12 d-flex gap-2 justify-content-end">
 <button
 onClick={handleSearch}
 className="btn btn-primary px-4"
 style={{ 
 background: 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', 
 border: 'none',
 borderRadius: '10px',
 fontWeight: '600',
 boxShadow: '0 4px 15px rgba(43, 76, 126, 0.3)'
 }}
 disabled={loading}
 >
 <i className="fa fa-search me-2"></i>
 {loading ? 'Recherche en cours...' : 'Rechercher'}
 </button>
 
 {isSearchActive && (
 <button
 onClick={handleResetSearch}
 className="btn btn-outline-secondary px-4"
 style={{ borderRadius: '10px', fontWeight: '600' }}
 >
 <i className="fa fa-redo me-2"></i>
 Réinitialiser
 {(selectedTags.length > 0 || searchKeyword) && (
 <span style={{marginLeft:'6px',background:'#dc3545',color:'white',borderRadius:'10px',padding:'1px 7px',fontSize:'0.72rem',fontWeight:'700'}}>
 {selectedTags.length + (searchKeyword ? 1 : 0)} filtre{selectedTags.length + (searchKeyword ? 1 : 0) > 1 ? 's' : ''}
 </span>
 )}
 </button>
 )}
 </div>
 </div>
 </div>
 </div>
 
 {loading && (
 <div className="alert alert-info mt-3" style={{borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'}}>
 <div className="d-flex align-items-center justify-content-between">
 <div className="d-flex align-items-center gap-3">
 <div className="spinner-border text-primary" role="status" style={{width: '1.5rem', height: '1.5rem'}}>
 <span className="visually-hidden">Loading...</span>
 </div>
 <div>
 <div style={{color: '#1976d2', fontWeight: '600', marginBottom: '4px'}}>
 Recherche en cours...
 </div>
 <div style={{color: '#1976d2', fontSize: '0.9rem'}}>
 Lot {searchProgress.current}/{searchProgress.total} • {hotels.length} hôtels trouvés
 </div>
 </div>
 </div>
 {searchProgress.total > 0 && (
 <div style={{minWidth: '100px', textAlign: 'right'}}>
 <div className="progress" style={{height: '8px', borderRadius: '10px', background: '#ffffff'}}>
 <div 
 className="progress-bar" 
 style={{
 width: `${(searchProgress.current / searchProgress.total) * 100}%`,
 background: 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)',
 transition: 'width 0.3s ease'
 }}
 />
 </div>
 <small style={{color: '#1976d2', fontWeight: '500'}}>
 {Math.round((searchProgress.current / searchProgress.total) * 100)}%
 </small>
 </div>
 )}
 </div>
 </div>
 )}
 </div>

 {loading ? (
 <div style={{textAlign: 'center', padding: '60px 0'}}>
 <div style={{width: '50px', height: '50px', border: '4px solid #f3f3f3', borderTop: '4px solid #01225C', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 20px'}}></div>
 <p style={{color: '#6c757d', fontSize: '1.1rem'}}>Recherche en cours...</p>
 <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}`}</style>
 </div>
 ) : currentHotels.length === 0 ? (
 <div style={{textAlign: 'center', padding: '60px 20px'}}>
 <i className="fa fa-hotel" style={{fontSize: '4rem', color: '#dee2e6', marginBottom: '20px'}}></i>
 <h3 style={{color: '#6c757d', marginBottom: '10px'}}>Aucun hôtel trouvé</h3>
 <p style={{color: '#adb5bd'}}>Essayez de modifier vos critères de recherche</p>
 </div>
 ) : (
 <>
 <div className="row g-4">
 {currentHotels.map((hotel, index) => {
 // Safety check
 if (!hotel || !hotel.Id) {
 console.warn("Invalid hotel object:", hotel);
 return null;
 }
 
 return (
 <div key={hotel.Id} className="col-lg-4 col-md-6" style={{animation: 'fadeInUp 0.5s ease-out', animationDelay: `${(index % 6) * 0.05}s`, animationFillMode: 'both'}}>
 <div style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,0.08)', transition: 'all 0.4s ease', background: '#fff', height: '100%', display: 'flex', flexDirection: 'column'}} onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-10px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(43, 76, 126, 0.2)';}} onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';}}>
 <div style={{position: 'relative', overflow: 'hidden', height: '250px'}}>
 <LazyImage src={hotel.Image || '/assets/img/default-hotel.jpg'} alt={hotel.Name || 'Hotel'} wrapperStyle={{height: '250px'}} style={{transition: 'transform 0.6s ease'}} onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}/>
 {hotel.Category?.Star && (
 <div style={{position: 'absolute', top: '15px', right: '15px', background: 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', color: 'white', padding: '8px 16px', borderRadius: '25px', fontSize: '0.85rem', fontWeight: '600', boxShadow: '0 4px 15px rgba(43, 76, 126, 0.4)', display: 'flex', alignItems: 'center', gap: '5px'}}>
 <span style={{color: '#FFD700', fontSize: '1rem'}}>★</span>{hotel.Category.Star}
 </div>
 )}
 </div>
 <div style={{padding: '25px', flex: '1', display: 'flex', flexDirection: 'column'}}>
 <h4 style={{color: '#01225C', fontWeight: '700', marginBottom: '15px', fontSize: '1.3rem', lineHeight: '1.4'}}>{hotel.Name || 'Nom non disponible'}</h4>
 {hotel.Category?.Title && (
 <p style={{color: '#6c757d', fontSize: '0.9rem', marginBottom: '12px', fontWeight: '500'}}>{hotel.Category.Title}</p>
 )}
 <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '15px', color: '#6c757d', fontSize: '0.9rem'}}>
 <i className="fa fa-map-marker-alt" style={{color: '#01225C', marginTop: '3px', fontSize: '1rem'}}></i>
 <div>
 <div style={{fontWeight: '600', color: '#495057'}}>{hotel.City?.Name || ''}{hotel.City?.Country?.Name ? `, ${hotel.City.Country.Name}` : ''}</div>
 {hotel.Adress && (
 <div style={{fontSize: '0.85rem', marginTop: '2px'}}>{hotel.Adress}</div>
 )}
 </div>
 </div>
         <div style={{marginTop: 'auto', paddingTop: '15px', borderTop: '1px solid #e9ecef'}}>
          {hotel.Facilities && hotel.Facilities.length > 0 && (
           <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px'}}>
            {hotel.Facilities.slice(0, 3).map((facility, i) => (
            <span key={i} style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', color: '#495057', padding: '6px 12px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: '500', border: '1px solid #dee2e6'}}>{facility.Title}</span>
            ))}
            {hotel.Facilities.length > 3 && (<span style={{color: '#01225C', padding: '6px 12px', fontSize: '0.75rem', fontWeight: '600'}}>+{hotel.Facilities.length - 3} plus</span>)}
           </div>
          )}
          {(() => {
           const priceInfo = getMinPrice(hotel.AvailablePrices ?? hotel.Price);
           return (
            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
             {/* Prix — visible dès qu'une recherche retourne un prix */}
             {priceInfo && (
              <div style={{flex: '1', background: 'linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%)', borderRadius: '10px', padding: '8px 12px', border: '1px solid #c8d8ff', minWidth: 0}}>
               <div style={{fontSize: '0.62rem', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.6px'}}>À partir de</div>
               <div style={{color: '#01225C', fontWeight: '800', fontSize: '1.15rem', lineHeight: '1.1', whiteSpace: 'nowrap'}}>{Number(priceInfo.price).toLocaleString('fr-TN')} <span style={{fontSize: '0.75rem'}}>TND</span></div>
               {priceInfo.boarding && <div style={{fontSize: '0.65rem', color: '#4a6da7', fontWeight: '500', marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{priceInfo.boarding}</div>}
              </div>
             )}
             <button onClick={() => openModal(hotel)} style={{flex: priceInfo ? '0 0 auto' : '1', padding: '12px 18px', background: 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', color: 'white', border: 'none', borderRadius: '10px', fontSize: '0.95rem', fontWeight: '600', cursor: 'pointer', transition: 'all 0.3s ease', boxShadow: '0 4px 15px rgba(43, 76, 126, 0.3)', whiteSpace: 'nowrap'}} onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(43, 76, 126, 0.4)';}} onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 15px rgba(43, 76, 126, 0.3)';}}>Voir les détails</button>
            </div>
           );
          })()}
         </div>
 </div>
 </div>
 <style>{`
 @keyframes fadeInUp {
 from {
 opacity: 0;
 transform: translateY(30px);
 }
 to {
 opacity: 1;
 transform: translateY(0);
 }
 }
 `}</style>
 </div>
 )})}
 </div>
 
 {loading && (
 <div style={{textAlign: 'center', marginTop: '40px', padding: '20px', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', borderRadius: '15px'}}>
 <div className="spinner-border text-primary mb-2" role="status" style={{width: '2rem', height: '2rem'}}>
 <span className="visually-hidden">Loading...</span>
 </div>
 <p style={{color: '#01225C', fontWeight: '600', margin: 0}}>Recherche de plus d'hôtels...</p>
 </div>
 )}
 </>
 )}

 {totalPages > 1 && (
 <>
 <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '32px', gap: '10px', flexWrap: 'wrap'}}>
 <button onClick={() => currentPage > 1 && paginate(currentPage - 1)} disabled={currentPage === 1} style={{padding: '10px 20px', background: currentPage === 1 ? '#e9ecef' : 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', color: currentPage === 1 ? '#6c757d' : 'white', border: 'none', borderRadius: '10px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', fontSize: '0.9rem', fontWeight: '600', transition: 'all 0.3s ease', boxShadow: currentPage === 1 ? 'none' : '0 4px 15px rgba(43, 76, 126, 0.3)'}}><i className="fa fa-chevron-left"></i> Précédent</button>
 <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
 {[...Array(totalPages)].map((_, index) => {
 const pageNumber = index + 1;
 if (pageNumber === 1 || pageNumber === totalPages || (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)) {
 return (<button key={pageNumber} onClick={() => paginate(pageNumber)} style={{width: '45px', height: '45px', background: currentPage === pageNumber ? 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)' : 'white', color: currentPage === pageNumber ? 'white' : '#01225C', border: currentPage === pageNumber ? 'none' : '2px solid #01225C', borderRadius: '10px', cursor: 'pointer', fontSize: '0.95rem', fontWeight: '600', transition: 'all 0.3s ease', boxShadow: currentPage === pageNumber ? '0 4px 15px rgba(43, 76, 126, 0.4)' : '0 2px 8px rgba(0,0,0,0.08)'}}>{pageNumber}</button>);
 } else if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
 return (<span key={pageNumber} style={{width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6c757d', fontSize: '1.2rem'}}>...</span>);
 }
 return null;
 })}
 </div>
 <button onClick={() => currentPage < totalPages && paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{padding: '10px 20px', background: currentPage === totalPages ? '#e9ecef' : 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', color: currentPage === totalPages ? '#6c757d' : 'white', border: 'none', borderRadius: '10px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', fontSize: '0.9rem', fontWeight: '600', transition: 'all 0.3s ease', boxShadow: currentPage === totalPages ? 'none' : '0 4px 15px rgba(43, 76, 126, 0.3)'}}>Suivant <i className="fa fa-chevron-right"></i></button>
 </div>
 <div style={{textAlign: 'center', marginTop: '20px', color: '#6c757d', fontSize: '0.9rem'}}>Page {currentPage} sur {totalPages} • {hotels.length} hôtels au total</div>
 </>
 )}
 </div>

 {showModal && selectedHotel && (() => {
 const detail = hotelDetails.get(selectedHotel.Id);
 const priceInfo = getMinPrice(selectedHotel.AvailablePrices ?? selectedHotel.Price);
 const heroImage = detail?.Album?.[0]?.Url || selectedHotel.Image;
 return (
 <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.75)',display:'flex',justifyContent:'center',alignItems:'center',zIndex:9999,padding:'20px',overflowY:'auto'}} onClick={closeModal}>
 <div style={{background:'white',borderRadius:'20px',maxWidth:'900px',width:'100%',maxHeight:'92vh',overflowY:'auto',position:'relative',boxShadow:'0 20px 60px rgba(0,0,0,0.35)',animation:'modalFadeIn 0.3s ease'}} onClick={e=>e.stopPropagation()}>

 {/* Close */}
 <button onClick={closeModal} style={{position:'absolute',top:'16px',right:'16px',width:'38px',height:'38px',borderRadius:'50%',background:'white',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.4rem',color:'#01225C',boxShadow:'0 4px 15px rgba(0,0,0,0.2)',zIndex:10}}>×</button>

 {/* Hero */}
 <div style={{position:'relative',height:'300px',overflow:'hidden',borderRadius:'20px 20px 0 0'}}>
 <img src={heroImage} alt={selectedHotel.Name} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
 <div style={{position:'absolute',inset:0,background:'linear-gradient(to top,rgba(1,34,92,0.8) 0%,transparent 55%)'}}/>
 <div style={{position:'absolute',bottom:'20px',left:'28px',color:'white'}}>
 <div style={{fontSize:'1.6rem',fontWeight:'800',textShadow:'0 2px 10px rgba(0,0,0,0.5)',marginBottom:'6px'}}>{selectedHotel.Name}</div>
 <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
 {Array.from({length: selectedHotel.Category?.Star||0}).map((_,i)=><span key={i} style={{color:'#FFD700',fontSize:'1.1rem'}}>★</span>)}
 <span style={{fontSize:'0.9rem',opacity:0.9,marginLeft:'6px'}}>{selectedHotel.Category?.Title}</span>
 </div>
 </div>
 {/* Price badge if search done */}
 {priceInfo && (
 <div style={{position:'absolute',top:'16px',left:'16px',background:'rgba(1,34,92,0.92)',color:'white',padding:'8px 16px',borderRadius:'20px',backdropFilter:'blur(4px)'}}>
 <div style={{fontSize:'0.65rem',fontWeight:'700',textTransform:'uppercase',letterSpacing:'0.5px',opacity:0.8}}>À partir de</div>
 <div style={{fontWeight:'800',fontSize:'1.1rem',lineHeight:1}}>{Number(priceInfo.price).toLocaleString('fr-TN',{minimumFractionDigits:0,maximumFractionDigits:0})} <span style={{fontSize:'0.7rem'}}>TND</span></div>
 {priceInfo.boarding && <div style={{fontSize:'0.65rem',opacity:0.85,marginTop:'2px'}}>{priceInfo.boarding}</div>}
 </div>
 )}
 </div>

 {/* Album thumbnails */}
 {detail?.Album?.length > 0 && (
 <div style={{display:'flex',gap:'6px',padding:'10px 16px',background:'#f8fafc',overflowX:'auto'}}>
 {detail.Album.map((photo,i)=>(
 <img key={i} src={photo.Url} alt={photo.Alt||''} style={{height:'70px',width:'105px',objectFit:'cover',borderRadius:'8px',flexShrink:0,cursor:'pointer',border:'2px solid transparent',transition:'border-color 0.2s'}} onMouseEnter={e=>e.target.style.borderColor='#01225C'} onMouseLeave={e=>e.target.style.borderColor='transparent'}/>
 ))}
 </div>
 )}

 <div style={{padding:'24px 30px'}}>

 {/* Location + contact */}
 <div style={{display:'flex',alignItems:'flex-start',gap:'10px',padding:'14px 18px',background:'#f8fafc',borderRadius:'12px',border:'1px solid #e2e8f0',marginBottom:'20px'}}>
 <i className="fa fa-map-marker-alt" style={{color:'#01225C',fontSize:'1rem',marginTop:'3px'}}/>
 <div style={{flex:1}}>
 <div style={{fontWeight:'700',color:'#01225C'}}>{selectedHotel.City?.Name}{selectedHotel.City?.Country?.Name ? `, ${selectedHotel.City.Country.Name}` : ''}</div>
 {selectedHotel.Adress && <div style={{color:'#64748b',fontSize:'0.85rem',marginTop:'2px'}}>{selectedHotel.Adress}</div>}
 {(detail?.Phone||detail?.Email) && (
 <div style={{display:'flex',gap:'16px',marginTop:'8px',fontSize:'0.82rem',color:'#475569'}}>
 {detail.Phone && <span><i className="fa fa-phone me-1"/>{detail.Phone}</span>}
 {detail.Email && <span><i className="fa fa-envelope me-1"/>{detail.Email}</span>}
 </div>
 )}
 </div>
 {(detail?.CheckIn||detail?.CheckOut) && (
 <div style={{textAlign:'right',fontSize:'0.78rem',color:'#64748b',flexShrink:0}}>
 {detail.CheckIn && <div>Check-in : <strong>{detail.CheckIn}</strong></div>}
 {detail.CheckOut && <div>Check-out : <strong>{detail.CheckOut}</strong></div>}
 </div>
 )}
 </div>

 {/* Description */}
 {detail?.LongDescription && (
 <div style={{marginBottom:'20px'}}>
 <h3 style={{color:'#01225C',fontSize:'1rem',fontWeight:'700',marginBottom:'10px',display:'flex',alignItems:'center',gap:'8px'}}><i className="fa fa-info-circle"/>Description</h3>
 <div style={{color:'#475569',fontSize:'0.88rem',lineHeight:'1.7',maxHeight:'150px',overflowY:'auto'}} dangerouslySetInnerHTML={{__html:detail.LongDescription}}/>
 </div>
 )}

 {/* Boarding prices from HotelSearch — selectable arrangement cards */}
 {(() => {
 const boardingPrices = getBoardingPrices(selectedHotel.AvailablePrices ?? selectedHotel.Price);
 if (boardingPrices.length === 0) return null;
 return (
 <div style={{marginBottom:'20px'}}>
 <h3 style={{color:'#01225C',fontSize:'1rem',fontWeight:'700',marginBottom:'4px',display:'flex',alignItems:'center',gap:'8px'}}><i className="fa fa-utensils"/>Choisissez votre arrangement</h3>
 <p style={{color:'#64748b',fontSize:'0.8rem',marginBottom:'10px'}}>Cliquez sur une formule pour la sélectionner</p>
 <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
 {boardingPrices.map((b,i)=>{
 const isSelected = selectedBoarding?.code === b.code;
 return (
 <div key={i} onClick={() => setSelectedBoarding(isSelected ? null : b)}
 style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 16px',
 background: isSelected ? 'linear-gradient(135deg,#01225C,#1e3a5f)' : (i===0 ? 'linear-gradient(135deg,#eff6ff,#dbeafe)' : '#f8fafc'),
 borderRadius:'10px',
 border: isSelected ? '2px solid #01225C' : (i===0 ? '1px solid #bfdbfe' : '1px solid #e2e8f0'),
 cursor:'pointer',transition:'all 0.2s'}}>
 <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
 <div style={{width:'18px',height:'18px',borderRadius:'50%',border:`2px solid ${isSelected?'white':'#01225C'}`,background:isSelected?'white':'transparent',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
 {isSelected && <div style={{width:'8px',height:'8px',borderRadius:'50%',background:'#01225C'}}/>}
 </div>
 {i===0 && !isSelected && <span style={{fontSize:'0.65rem',fontWeight:'800',color:'white',background:'#01225C',padding:'2px 7px',borderRadius:'10px',textTransform:'uppercase'}}>Meilleur prix</span>}
 <span style={{fontWeight:'600',color:isSelected?'white':'#1e40af',fontSize:'0.88rem'}}>{b.name}</span>
 <span style={{fontSize:'0.72rem',color:isSelected?'rgba(255,255,255,0.7)':'#64748b',background:isSelected?'rgba(255,255,255,0.15)':'#e2e8f0',padding:'2px 8px',borderRadius:'10px'}}>{b.code}</span>
 </div>
 <div style={{fontWeight:'800',color:isSelected?'white':'#01225C',fontSize:'1rem',whiteSpace:'nowrap'}}>
 {Number(b.price).toLocaleString('fr-TN',{minimumFractionDigits:3,maximumFractionDigits:3})} <span style={{fontSize:'0.72rem',fontWeight:'600'}}>TND</span>
 </div>
 </div>
 );
 })}
 </div>
 {selectedBoarding && (
 <div style={{marginTop:'8px',padding:'8px 14px',background:'#d1fae5',borderRadius:'8px',border:'1px solid #6ee7b7',fontSize:'0.82rem',color:'#065f46',display:'flex',alignItems:'center',gap:'6px'}}>
 <i className="fa fa-check-circle"/><strong>{selectedBoarding.name}</strong> sélectionné
 </div>
 )}
 </div>
 );
 })()}

 {/* Boarding types from HotelDetail — selectable when no search prices available */}
 {getBoardingPrices(selectedHotel.AvailablePrices ?? selectedHotel.Price).length === 0 && detail?.Boarding?.length > 0 && (
 <div style={{marginBottom:'20px'}}>
 <h3 style={{color:'#01225C',fontSize:'1rem',fontWeight:'700',marginBottom:'4px',display:'flex',alignItems:'center',gap:'8px'}}><i className="fa fa-utensils"/>Choisissez votre arrangement</h3>
 <p style={{color:'#64748b',fontSize:'0.8rem',marginBottom:'10px'}}>Cliquez sur une formule pour la sélectionner</p>
 <div style={{display:'flex',flexWrap:'wrap',gap:'8px'}}>
 {detail.Boarding.map((b,i)=>{
 const isSelected = selectedBoarding?.code === b.Code;
 return (
 <span key={i} onClick={() => setSelectedBoarding(isSelected ? null : {name: b.Name, code: b.Code, price: null})}
 style={{padding:'6px 14px',cursor:'pointer',
 background: isSelected ? 'linear-gradient(135deg,#01225C,#1e3a5f)' : '#eff6ff',
 color: isSelected ? 'white' : '#1e40af',
 borderRadius:'20px',fontSize:'0.82rem',fontWeight:'600',
 border: isSelected ? '2px solid #01225C' : '1px solid #bfdbfe',
 transition:'all 0.2s'}}>
 {isSelected && <i className="fa fa-check me-1" style={{fontSize:'0.75rem'}}/>}
 {b.Name}
 </span>
 );
 })}
 </div>
 {selectedBoarding && (
 <div style={{marginTop:'8px',padding:'8px 14px',background:'#d1fae5',borderRadius:'8px',border:'1px solid #6ee7b7',fontSize:'0.82rem',color:'#065f46',display:'flex',alignItems:'center',gap:'6px'}}>
 <i className="fa fa-check-circle"/><strong>{selectedBoarding.name}</strong> sélectionné
 </div>
 )}
 </div>
 )}

 {/* Tags */}
 {detail?.Tag?.length > 0 && (
 <div style={{marginBottom:'20px'}}>
 <h3 style={{color:'#01225C',fontSize:'1rem',fontWeight:'700',marginBottom:'10px',display:'flex',alignItems:'center',gap:'8px'}}><i className="fa fa-star"/>Équipements & Atouts</h3>
 <div style={{display:'flex',flexWrap:'wrap',gap:'8px'}}>
 {detail.Tag.map((t,i)=>(
 <span key={i} style={{padding:'6px 14px',background:'#f0fdf4',color:'#166534',borderRadius:'20px',fontSize:'0.82rem',fontWeight:'600',border:'1px solid #bbf7d0'}}>
 {t.Title}
 </span>
 ))}
 </div>
 </div>
 )}

 {/* Themes — from HotelSearch or HotelDetail */}
 {((selectedHotel.Theme?.length > 0) || (detail?.Theme?.length > 0)) && (
 <div style={{marginBottom:'20px'}}>
 <h3 style={{color:'#01225C',fontSize:'1rem',fontWeight:'700',marginBottom:'10px',display:'flex',alignItems:'center',gap:'8px'}}><i className="fa fa-heart"/>Thèmes</h3>
 <div style={{display:'flex',flexWrap:'wrap',gap:'8px'}}>
 {(selectedHotel.Theme || detail?.Theme || []).map((t,i)=>(
 <span key={i} style={{padding:'6px 14px',background:'linear-gradient(135deg,#01225C,#1e3a5f)',color:'white',borderRadius:'20px',fontSize:'0.8rem',fontWeight:'600'}}>{t}</span>
 ))}
 </div>
 </div>
 )}

 {/* Note — from HotelSearch or HotelDetail */}
 {(selectedHotel.Note || detail?.Note) && (
 <div style={{background:'#fffbeb',border:'1px solid #fcd34d',borderRadius:'12px',padding:'16px 18px',marginBottom:'20px'}}>
 <div style={{color:'#92400e',fontWeight:'700',fontSize:'0.88rem',marginBottom:'8px',display:'flex',alignItems:'center',gap:'6px'}}><i className="fa fa-exclamation-triangle"/>Informations importantes</div>
 <div style={{color:'#78350f',fontSize:'0.8rem',lineHeight:'1.6'}} dangerouslySetInnerHTML={{__html: selectedHotel.Note || detail?.Note}}/>
 </div>
 )}

 {/* If detail not yet loaded */}
 {!detail && (
 <div style={{textAlign:'center',padding:'20px',color:'#94a3b8',fontSize:'0.85rem'}}>
 <i className="fa fa-spinner fa-spin me-2"/>Chargement des détails...
 </div>
 )}

 {/* Reserve */}
 <button
 onClick={openResModal}
 style={{display:'block',width:'100%',padding:'15px',background:'linear-gradient(135deg,#01225C,#1e3a5f)',color:'white',border:'none',borderRadius:'12px',fontSize:'1rem',fontWeight:'700',cursor:'pointer',textAlign:'center',boxShadow:'0 6px 20px rgba(43,76,126,0.4)',transition:'all 0.2s'}}
 onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow='0 10px 28px rgba(43,76,126,0.5)';}}
 onMouseLeave={e=>{e.currentTarget.style.transform='';e.currentTarget.style.boxShadow='0 6px 20px rgba(43,76,126,0.4)';}}>
 <i className="fa fa-calendar-check me-2"/>
 {selectedBoarding ? `Réserver — ${selectedBoarding.name}` : 'Réserver maintenant'}
 </button>
 </div>
 </div>
 <style>{`@keyframes modalFadeIn{from{opacity:0;transform:scale(0.92)}to{opacity:1;transform:scale(1)}}`}</style>
 </div>
 );
 })()}
 {/* ========== RESERVATION STEPPER MODAL ========== */}
 {showResModal && createPortal(
 <>
 <style>{`
 @keyframes resModalIn{from{opacity:0;transform:scale(0.93) translateY(20px)}to{opacity:1;transform:scale(1) translateY(0)}}
 @keyframes checkPop{0%{transform:scale(0)}60%{transform:scale(1.2)}100%{transform:scale(1)}}
 .res-input:focus{border-color:#01225C!important;box-shadow:0 0 0 3px rgba(1,34,92,0.1)!important;}
 `}</style>
 {/* Backdrop */}
 <div onClick={closeResModal} style={{position:'fixed',inset:0,background:'rgba(1,10,30,0.6)',backdropFilter:'blur(5px)',zIndex:200000}}/>
 {/* Panel */}
 <div style={{position:'fixed',inset:0,display:'flex',alignItems:'center',justifyContent:'center',zIndex:200001,padding:'16px',pointerEvents:'none'}}>
 <div style={{background:'white',borderRadius:'22px',width:'100%',maxWidth:'560px',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 32px 80px rgba(1,34,92,0.28)',pointerEvents:'all',animation:'resModalIn 0.28s cubic-bezier(0.34,1.4,0.64,1)'}}>

 {/* Modal header + stepper */}
 <div style={{padding:'22px 24px 16px',borderBottom:'1px solid #f1f5f9',flexShrink:0}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
 <h3 style={{margin:0,fontWeight:'800',fontSize:'1.1rem',color:'#01225C'}}>
 {resStep===1 ? ' Votre séjour' : resStep===2 ? ' Vos coordonnées' : '✅ Demande envoyée'}
 </h3>
 <button onClick={closeResModal} style={{background:'#f1f5f9',border:'none',borderRadius:'50%',width:'34px',height:'34px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.2rem',color:'#64748b',flexShrink:0}}>×</button>
 </div>
 {/* Step indicators */}
 <div style={{display:'flex',alignItems:'center'}}>
 {['Séjour','Coordonnées','Confirmation'].map((label,i)=>{
 const s=i+1, done=s<resStep, active=s===resStep;
 return (
 <React.Fragment key={s}>
 <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'5px',flexShrink:0}}>
 <div style={{width:'34px',height:'34px',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.85rem',fontWeight:'800',transition:'all 0.35s',
 background: done?'#22c55e':active?'linear-gradient(135deg,#01225C,#1e3a5f)':'#e2e8f0',
 color: done||active?'white':'#94a3b8',
 boxShadow: active?'0 4px 14px rgba(1,34,92,0.35)':'none'}}>
 {done ? <i className="fa fa-check" style={{fontSize:'0.7rem'}}/> : s}
 </div>
 <span style={{fontSize:'0.65rem',fontWeight:'700',whiteSpace:'nowrap',color:active?'#01225C':done?'#22c55e':'#94a3b8',letterSpacing:'0.03em'}}>{label}</span>
 </div>
 {s<3 && <div style={{flex:1,height:'2.5px',margin:'0 8px',marginBottom:'17px',borderRadius:'2px',transition:'background 0.35s',background:done?'#22c55e':'#e2e8f0'}}/>}
 </React.Fragment>
 );})}
 </div>
 </div>

 {/* Modal body */}
 <div style={{flex:1,overflowY:'auto',padding:'20px 24px'}}>

 {/* STEP 1 — Hotel recap */}
 {resStep===1 && resHotel && (
 <div>
 <div style={{display:'flex',gap:'14px',marginBottom:'18px',background:'#f8fafc',borderRadius:'14px',padding:'14px',border:'1px solid #e2e8f0'}}>
 <img src={resHotel.image} alt={resHotel.name} onError={e=>{e.target.src='/assets/img/default-hotel.jpg';}}
 style={{width:'96px',height:'76px',objectFit:'cover',borderRadius:'10px',flexShrink:0}}/>
 <div>
 <div style={{fontWeight:'800',fontSize:'1rem',color:'#01225C',marginBottom:'4px',lineHeight:1.2}}>{resHotel.name}</div>
 <div style={{display:'flex',gap:'2px',marginBottom:'5px'}}>
 {Array.from({length:Number(resHotel.stars)||0}).map((_,i)=><span key={i} style={{color:'#f59e0b',fontSize:'0.82rem'}}>★</span>)}
 </div>
 <div style={{color:'#64748b',fontSize:'0.8rem',display:'flex',alignItems:'center',gap:'5px'}}>
 <i className="fa fa-map-marker-alt" style={{color:'#01225C',fontSize:'0.75rem'}}/> {resHotel.city}
 </div>
 </div>
 </div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
 {[
 resHotel.checkIn && {icon:'fa-calendar-check',iconColor:'#22c55e',label:'Check-In',val:resHotel.checkIn},
 resHotel.checkOut && {icon:'fa-calendar-times',iconColor:'#ef4444',label:'Check-Out',val:resHotel.checkOut},
 {icon:'fa-door-open',iconColor:'#01225C',label:'Chambres',val:`${resHotel.roomsCount} chambre${resHotel.roomsCount>1?'s':''}`},
 {icon:'fa-users',iconColor:'#01225C',label:'Voyageurs',val:`${resHotel.adults} adulte${resHotel.adults>1?'s':''}${resHotel.children>0?` · ${resHotel.children} enfant${resHotel.children>1?'s':''}`:''}` },
 ].filter(Boolean).map((item,i)=>(
 <div key={i} style={{padding:'12px',background:'white',borderRadius:'12px',border:'1px solid #e2e8f0'}}>
 <div style={{fontSize:'0.64rem',color:'#94a3b8',fontWeight:'700',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:'4px'}}>{item.label}</div>
 <div style={{fontWeight:'700',color:'#0f172a',fontSize:'0.88rem',display:'flex',alignItems:'center',gap:'6px'}}>
 <i className={`fa ${item.icon}`} style={{color:item.iconColor,fontSize:'0.78rem'}}/> {item.val}
 </div>
 </div>
 ))}
 {resHotel.arrangement && (
 <div style={{padding:'12px',background:'linear-gradient(135deg,#eff6ff,#dbeafe)',borderRadius:'12px',border:'1px solid #bfdbfe',gridColumn:'span 2'}}>
 <div style={{fontSize:'0.64rem',color:'#3b82f6',fontWeight:'700',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:'4px'}}>Arrangement sélectionné</div>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
 <div style={{fontWeight:'700',color:'#1e40af',fontSize:'0.9rem',display:'flex',alignItems:'center',gap:'6px'}}>
 <i className="fa fa-utensils" style={{fontSize:'0.75rem'}}/> {resHotel.arrangement}
 </div>
 {resHotel.arrangementPrice && (
 <span style={{fontWeight:'800',color:'#01225C',fontSize:'1rem'}}>{Number(resHotel.arrangementPrice).toLocaleString('fr-TN',{minimumFractionDigits:3})} TND</span>
 )}
 </div>
 </div>
 )}
 {!resHotel.arrangement && resHotel.price && (
 <div style={{padding:'12px',background:'linear-gradient(135deg,#f0fdf4,#dcfce7)',borderRadius:'12px',border:'1px solid #bbf7d0',gridColumn:'span 2'}}>
 <div style={{fontSize:'0.64rem',color:'#16a34a',fontWeight:'700',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:'4px'}}>Prix indicatif (à partir de)</div>
 <div style={{fontWeight:'800',color:'#15803d',fontSize:'1.1rem'}}>{Number(resHotel.price).toLocaleString('fr-TN',{minimumFractionDigits:3})} TND</div>
 </div>
 )}
 </div>
 {(!resHotel.checkIn||!resHotel.checkOut) && (
 <div style={{marginTop:'14px',padding:'10px 14px',background:'#fffbeb',border:'1px solid #fcd34d',borderRadius:'10px',fontSize:'0.78rem',color:'#92400e',display:'flex',alignItems:'center',gap:'8px'}}>
 <i className="fa fa-info-circle"/> Aucune date sélectionnée — le tarif vous sera confirmé par nos conseillers.
 </div>
 )}
 </div>
 )}

 {/* STEP 2 — Form */}
 {resStep===2 && (() => {
 const fi = (key) => ({
 ...resInputCss,
 borderColor: resFieldErrors[key] ? '#ef4444' : '#e2e8f0',
 boxShadow: resFieldErrors[key] ? '0 0 0 3px rgba(239,68,68,0.12)' : 'none',
 });
 const clearErr = (key) => {
 if (resFieldErrors[key]) setResFieldErrors(prev => { const n={...prev}; delete n[key]; return n; });
 };
 const ErrMsg = ({field}) => resFieldErrors[field]
 ? <div style={{color:'#ef4444',fontSize:'0.72rem',fontWeight:'600',marginTop:'4px',display:'flex',alignItems:'center',gap:'4px'}}>
 <i className="fa fa-exclamation-circle" style={{fontSize:'0.68rem'}}/>{resFieldErrors[field]}
 </div> : null;
 return (
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>
 <div style={{gridColumn:'span 2'}}>
 <ResField label="Nom et Prénom *">
 <input className="res-input" type="text" value={resForm.nom_prenom} placeholder="Jean Dupont"
 onChange={e=>{setResForm(f=>({...f,nom_prenom:e.target.value}));clearErr('nom_prenom');}}
 style={fi('nom_prenom')}/>
 <ErrMsg field="nom_prenom"/>
 </ResField>
 </div>
 <div style={{gridColumn:'span 2'}}>
 <ResField label="Adresse Email *">
 <input className="res-input" type="email" value={resForm.email} placeholder="jean@example.com"
 onChange={e=>{setResForm(f=>({...f,email:e.target.value}));clearErr('email');}}
 style={fi('email')}/>
 <ErrMsg field="email"/>
 </ResField>
 </div>
 <div style={{gridColumn:'span 2'}}>
 <ResField label="Adresse Complète">
 <input className="res-input" type="text" value={resForm.adresse} placeholder="123 Rue de la Paix"
 onChange={e=>setResForm(f=>({...f,adresse:e.target.value}))}
 style={{...resInputCss}}/>
 </ResField>
 </div>
 <ResField label="Ville">
 <input className="res-input" type="text" value={resForm.ville} placeholder="Tunis"
 onChange={e=>setResForm(f=>({...f,ville:e.target.value}))}
 style={{...resInputCss}}/>
 </ResField>
 <ResField label="Téléphone *">
 <input className="res-input" type="tel" value={resForm.telephone} placeholder="+216 XX XXX XXX"
 onChange={e=>{setResForm(f=>({...f,telephone:e.target.value}));clearErr('telephone');}}
 style={fi('telephone')}/>
 <ErrMsg field="telephone"/>
 </ResField>
 <ResField label="WhatsApp">
 <input className="res-input" type="tel" value={resForm.whatsapp} placeholder="+216 XX XXX XXX"
 onChange={e=>setResForm(f=>({...f,whatsapp:e.target.value}))}
 style={{...resInputCss}}/>
 </ResField>
 <ResField label="Mode de Paiement">
 <select value={resForm.mode_paiement} onChange={e=>setResForm(f=>({...f,mode_paiement:e.target.value}))}
 style={{...resInputCss,appearance:'auto'}}>
 <option value="">Sélectionner...</option>
 <option>Espèces</option>
 <option>Virement bancaire</option>
 <option>Chèque</option>
 <option>Carte bancaire</option>
 <option>Traite</option>
 </select>
 </ResField>
 <div style={{gridColumn:'span 2'}}>
 <ResField label="Demande spécifique">
 <select value={resForm.demande_specifique} onChange={e=>setResForm(f=>({...f,demande_specifique:e.target.value}))}
 style={{...resInputCss,appearance:'auto'}}>
 <option>Réservation hôtel</option>
 <option>Demande spécifique / Demander un devis</option>
 <option>Voyage de noces</option>
 <option>Voyage d'affaires</option>
 <option>Voyage en famille</option>
 </select>
 </ResField>
 </div>
 <div style={{gridColumn:'span 2'}}>
 <ResField label="Remarque">
 <textarea value={resForm.remarque} onChange={e=>setResForm(f=>({...f,remarque:e.target.value}))}
 placeholder="Précisez votre demande (chambre vue mer, lit bébé, accessibilité…)"
 className="res-input"
 style={{...resInputCss,resize:'vertical',minHeight:'90px'}}/>
 </ResField>
 </div>
 </div>
 );
 })()}

 {/* STEP 3 — Success */}
 {resStep===3 && (
 <div style={{textAlign:'center',padding:'24px 0'}}>
 <div style={{width:'72px',height:'72px',borderRadius:'50%',background:'linear-gradient(135deg,#22c55e,#16a34a)',margin:'0 auto 20px',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(34,197,94,0.35)',animation:'checkPop 0.5s cubic-bezier(0.34,1.56,0.64,1)'}}>
 <i className="fa fa-check" style={{color:'white',fontSize:'2rem'}}/>
 </div>
 <h4 style={{color:'#15803d',fontWeight:'800',marginBottom:'8px',fontSize:'1.15rem'}}>Demande envoyée avec succès !</h4>
 <p style={{color:'#64748b',fontSize:'0.88rem',lineHeight:'1.6',marginBottom:'20px'}}>
 Nos conseillers vont étudier votre demande pour <strong style={{color:'#01225C'}}>{resHotel?.name}</strong> et vous recontacterons dans les plus brefs délais.
 </p>
 <div style={{background:'#f8fafc',borderRadius:'12px',padding:'14px 16px',border:'1px solid #e2e8f0',textAlign:'left',fontSize:'0.82rem',color:'#475569'}}>
 <div style={{fontWeight:'700',color:'#0f172a',marginBottom:'8px',fontSize:'0.85rem'}}>Récapitulatif envoyé :</div>
 {[
 ['Nom', resForm.nom_prenom],
 ['Email', resForm.email],
 ['Hôtel', resHotel?.name],
 ['Check-In', resHotel?.checkIn||'Non précisé'],
 ['Check-Out', resHotel?.checkOut||'Non précisé'],
 ['Arrangement', resHotel?.arrangement||'Non précisé'],
 ].map(([k,v])=>v&&<div key={k} style={{display:'flex',gap:'8px',marginBottom:'4px'}}><span style={{minWidth:'90px',fontWeight:'600',color:'#94a3b8'}}>{k}</span><span>{v}</span></div>)}
 </div>
 </div>
 )}
 </div>

 {/* Modal footer */}
 <div style={{padding:'14px 24px',borderTop:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0,background:'#fafbfc',borderRadius:'0 0 22px 22px'}}>
 {resStep===1 ? (
 <button onClick={closeResModal} style={{background:'none',border:'1px solid #e2e8f0',color:'#64748b',borderRadius:'10px',padding:'9px 20px',fontSize:'0.88rem',fontWeight:'600',cursor:'pointer'}}>Annuler</button>
 ) : resStep===2 ? (
 <button onClick={()=>setResStep(1)} style={{background:'none',border:'1px solid #e2e8f0',color:'#64748b',borderRadius:'10px',padding:'9px 20px',fontSize:'0.88rem',fontWeight:'600',cursor:'pointer',display:'flex',alignItems:'center',gap:'6px'}}>
 <i className="fa fa-arrow-left" style={{fontSize:'0.75rem'}}/> Retour
 </button>
 ) : (
 <div/>
 )}
 {resStep===1 && (
 <button onClick={()=>setResStep(2)} style={{background:'linear-gradient(135deg,#01225C,#1e3a5f)',border:'none',color:'white',borderRadius:'10px',padding:'9px 24px',fontSize:'0.88rem',fontWeight:'700',cursor:'pointer',display:'flex',alignItems:'center',gap:'8px',boxShadow:'0 4px 14px rgba(1,34,92,0.3)'}}>
 Continuer <i className="fa fa-arrow-right" style={{fontSize:'0.75rem'}}/>
 </button>
 )}
 {resStep===2 && (
 <button onClick={submitReservation} disabled={resSending} style={{background:'linear-gradient(135deg,#01225C,#1e3a5f)',border:'none',color:'white',borderRadius:'10px',padding:'9px 24px',fontSize:'0.88rem',fontWeight:'700',cursor:resSending?'not-allowed':'pointer',display:'flex',alignItems:'center',gap:'8px',opacity:resSending?0.7:1,boxShadow:'0 4px 14px rgba(1,34,92,0.3)'}}>
 {resSending ? <><i className="fa fa-spinner fa-spin"/> Envoi...</> : <><i className="fa fa-paper-plane"/> Envoyer la demande</>}
 </button>
 )}
 {resStep===3 && (
 <button onClick={closeResModal} style={{background:'linear-gradient(135deg,#22c55e,#16a34a)',border:'none',color:'white',borderRadius:'10px',padding:'9px 24px',fontSize:'0.88rem',fontWeight:'700',cursor:'pointer',boxShadow:'0 4px 14px rgba(34,197,94,0.3)'}}>
 Fermer
 </button>
 )}
 </div>

 </div>
 </div>
 </>,
 document.body
 )}
 {/* ========== END RESERVATION MODAL ========== */}

 {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
 </>
 );
};

export default HotelList;